//Custom CSS
import '../scss/global.scss'

//Elements
import './utils/utils'

//Blocks (loaded only on pages that actually render the map block)
if (document.querySelector('.map_gutemberg')) {
  import('./blocks/map-traject/index.js');
}
